import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import HeaderFFF from '../components/HeaderFFF'
import Header from '../components/Header'
import Footer from "../components/Footer";
import '../styles/contact.css';

export default function Contact() {
   const [isMobile, setIsMobile] = useState(window.innerWidth <= 1000);
   
       useEffect(() => {
           const handleResize = () => {
               setIsMobile(window.innerWidth <= 991);
           };
   
           window.addEventListener('resize', handleResize);
           return () => window.removeEventListener('resize', handleResize);
       }, []);

       const [open, setOpen] = useState(false);
   
       return(
           <>
           {isMobile ? <Header /> : <HeaderFFF />}
        <div id="contact">
        <div id="contact-header-container">
                <svg xmlns="http://www.w3.org/2000/svg" width="102" height="2" viewBox="0 0 102 2" fill="none">
                    <path d="M101 1H1" stroke="#BF9874" stroke-width="2" stroke-linecap="round"/>
                </svg>
                <h2>Contact Us</h2>
                <svg xmlns="http://www.w3.org/2000/svg" width="102" height="2" viewBox="0 0 102 2" fill="none">
                    <path d="M101 1H1" stroke="#BF9874" stroke-width="2" stroke-linecap="round"/>
                </svg>
            </div>
            <div id="location">
                <div id="left-loc">
                    <h4>Address</h4>
                    <a href="https://www.google.com/maps/dir//Corsianos+Lee+6+Ronrose+Dr+Suite+301+Concord,+ON+L4K+4R3/@43.7873224,-79.494028,785m/data=!3m1!1e3!4m8!4m7!1m0!1m5!1m1!1s0x882b2fe3d59f0b85:0x48ae420bdaf574da!2m2!1d-79.494028!2d43.7873224?entry=ttu&g_ep=EgoyMDI1MDczMC4wIKXMDSoASAFQAw%3D%3D">
                        6 Ronrose Dr - Suite 301<br/>
                        Concord, ON<br/>
                        L4K 4R3<br/>
                        Canada
                    </a>
                    <h4>Phone</h4>
                    <p>905-370-1091</p>
                    <h4>Fax</h4>
                    <p>905-370-1095</p>
                    <h4>Personal Injury Phone</h4>
                    <p>905-264-8686</p>
                    <h4>Personal Injury Fax</h4>
                    <p>905-264-0068</p>
                    <h4>Email</h4>
                    <a href="mailto:info@clvlaw.ca">info@clvlaw.ca</a>
                </div>
                <div id="right-loc">
                    <iframe id="map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2880.3029565686425!2d-79.4966029234638!3d43.78732624374511!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882b2fe3d59f0b85%3A0x48ae420bdaf574da!2sCorsianos%20Lee!5e0!3m2!1sen!2sca!4v1734630119775!5m2!1sen!2sca" width="600" height="450" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                </div>
            </div>
            <div id="form-container">
                <div id="form-header">
                    <h4>Get the Best Legal Counsel in the City!</h4>
                    <p>Fill in the form below and we will be in touch with you within the next 24 hours.</p>
                </div>
                <div id="form">
                    <form>
                        <div id="form-box">
                            <div>
                                <input type="text" placeholder="First Name" required/><br className="form-break"></br>
                                <input type="text" placeholder="Last Name" required/>
                            </div>
                            <div>
                                <input type="email" placeholder="Email" required/><br className="form-break"></br>
                                <input type="number" placeholder="Phone" required/>
                            </div>
                                <textarea type="text" placeholder="Message" required/>
                                <p><span className="asterisk">*</span>Please fill out all fields.</p>
                            </div>
                            <div id="checkbox-container">
                                <input id="checkbox" type="checkbox" required />
      <label htmlFor="checkbox">
        I have read the{" "}
        <span
          onClick={(e) => {
            e.preventDefault(); // prevent checkbox from toggling
            setOpen(true);
          }}
          style={{ color: "blue", textDecoration: "underline", cursor: "pointer" }}
        >
          disclaimer
        </span>.
      </label>
                            </div>
                            <button type="submit">Submit</button>
                    </form>
                </div>
            </div>
        </div>
        {open && (
        <div onClick={() => setOpen(false)} className="modal-overlay">
          <div className="modal-content">
            <button className="close-btn" onClick={() => setOpen(false)}>
              ✖
            </button>
            <h2>Privacy Policy</h2>
            <span id="privacy-text">
              Thank you for visiting our website. This policy establishes how we will handle information we learn about you from your visit to our site. We collect no personally identifiable information or identifiable business information about you when you visit our website unless you choose to provide that information to us.
              <br /><br />
              <h3>Automatic Collections</h3>
              For each HTTP request received (what your web browser generates when you request a page or part of a page from a website), we collect and store only the following information:
              <ul>
                <li>date and time</li>
                <li>originating IP address</li>
                <li>type of browser and operating system used (if provided by the browser)</li>
                <li>URL of the referring page (if provided by the browser)</li>
                <li>object requested</li>
                <li>completion status of the request</li>
                <li>pages visited</li>
              </ul>

              <h3>Use of Information</h3>
              When you provide information through this website, we will only use that information to respond to direct inquiries or to measure traffic to help us make our website more useful to visitors.
              <br /><br />

              <h3>Voluntary Information Collected</h3>
              When you register for e-newsletters or alerts, or when you attempt to access a secure extranet page, we ask for identification such as your name, email address and/or company name. If you're sending a resume to us, we ask for your name, email address, home address, and general inquiries into your professional aspirations. We do not provide or sell any of this information to third parties.
              <br /><br />

              <h3>Cookies</h3>
              We do not use "persistent cookies" or any persistent tracking methods to collect personally identifiable information or identifiable business information about visitors to our website.
              <br /><br />

              <h3>Policy Changes</h3>
              We reserve the right to change our policy regarding cookies and the collection of information from visitors at any time without advance notice. Should any new policy go into effect, we will post the changes on this website and the new policy will only apply to information collected thereafter. Any such policy changes will permit visitors to "opt out".
            </span><br></br>
          </div>
        </div>
      )}
        <Footer />
        </>
    );
}